/**
 * TDX 公車路線類別（與 scripts/lib/tdx-bus-route-type.js 對齊）
 * @see docs/active_specs/TDX_INTERCITY_BUS_SPEC.md
 */

export const ROUTE_TYPE = Object.freeze({
    CITY: 11,
    HIGHWAY: 12,
    NATIONAL_HIGHWAY: 13,
    SHUTTLE: 14
});

export const ROUTE_TYPE_LABEL = Object.freeze({
    11: '市區公車',
    12: '公路客運',
    13: '國道客運',
    14: '接駁車'
});

const INTERCITY_ROUTE_TYPES = new Set([ROUTE_TYPE.HIGHWAY, ROUTE_TYPE.NATIONAL_HIGHWAY]);

export function routeTypeFromRecord(row) {
    if (!row || typeof row !== 'object') return null;
    const v = row.h_route_type ?? row.RouteType ?? row.BusRouteType ?? row.busRouteType;
    if (v === undefined || v === null || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
}

export function isIntercityRoute(row) {
    if (row?.h_is_intercity === true) return true;
    const t = routeTypeFromRecord(row);
    return t != null && INTERCITY_ROUTE_TYPES.has(t);
}

/**
 * 長途客運（報表／分時圈公車圖要排除）。
 * - 權威：RouteType 12／13 或 h_is_intercity
 * - 過渡：市區層偶有「淡水-國道1號-南港」這類公路客運命名但 BusRouteType 仍為 11
 * - 保留：名稱含「快捷」的市區國道快捷（如 E01 旗美國道快捷）
 */
export function isLongDistanceCoach(row) {
    if (!row || typeof row !== 'object') return false;
    if (isIntercityRoute(row)) return true;

    const name = [row.ref, row.h_ref, row.name, row.h_name, row.h_route_name]
        .filter(Boolean)
        .map((s) => String(s))
        .join(' ');
    if (!name) return false;
    if (/快捷/.test(name)) return false;
    if (/國道客運|公路客運/.test(name)) return true;
    if (/國道\s*\d+\s*號/.test(name)) return true;
    return false;
}

export function shouldIncludeInCityBusReport(row) {
    return !isLongDistanceCoach(row);
}
